import { useState } from "react";
import { Calculator, BarChart3, CircleDot, Target, X, ArrowRight, ArrowLeft, Check } from "lucide-react";

const STEPS = [
  {
    icon: Calculator,
    title: "1 · Fase Calcolo",
    text: "Scegli campionato e squadre, poi inserisci le quote del tuo bookmaker (1X2 e Over/Under). Puoi anche consultare lo storico Head-to-Head e la data del match.",
  },
  {
    icon: BarChart3,
    title: "2 · Riepilogo Analisi",
    text: "Elabora le probabilità reali per ciascun esito, utilizzando un campione di riferimento di 10.000 dati storici e integrando le quote di mercato appena inserite.",
  },
  {
    icon: CircleDot,
    title: "3 · I Pallini",
    text: "Il sistema attiva gli indicatori di forza del segnale esclusivamente al verificarsi di una doppia condizione simultanea. Il pallino oro (Star) rappresenta il livello di segnale più alto disponibile.",
  },
  {
    icon: Target,
    title: "4 · Movimenti Consigliati",
    text: "La matrice finale con tutti i mercati e il Movimento Consigliato: la combo più probabile. Condividila con un tap.",
  },
];

export default function OnboardingTour({ onDone }) {
  const [step, setStep] = useState(0);
  const s = STEPS[step];
  const Icon = s.icon;
  const last = step === STEPS.length - 1;

  return (
    <div className="fixed inset-0 z-[60] bg-black/80 backdrop-blur-sm flex items-center justify-center px-4">
      <div data-testid="onboarding-tour" className="w-full max-w-md bg-black border border-amber-500/30 rounded-md gold-glow fade-up">
        <div className="flex items-center justify-between px-6 py-3.5 border-b border-amber-500/15">
          <span className="font-mono-data text-[10px] text-[#E3BC55]/80 uppercase tracking-widest">Guida Rapida · Zero Signals</span>
          <button data-testid="onboarding-skip-button" onClick={onDone} className="text-slate-500 hover:text-white transition-colors" title="Salta">
            <X className="w-5 h-5" />
          </button>
        </div>

        <div className="px-6 py-8 text-center">
          <div className="w-16 h-16 rounded-2xl bg-[#E3BC55]/10 border border-[#E3BC55]/40 flex items-center justify-center mx-auto mb-5">
            <Icon className="w-8 h-8 text-[#E3BC55]" />
          </div>
          <h3 className="font-heading font-bold text-xl text-[#E3BC55] uppercase tracking-wide mb-3">{s.title}</h3>
          <p className="text-sm text-slate-300 leading-relaxed min-h-[80px]">{s.text}</p>

          <div className="flex items-center justify-center gap-2 mt-6">
            {STEPS.map((_, i) => (
              <span
                key={i}
                className={`h-1.5 rounded-full transition-all ${i === step ? "w-6 bg-[#E3BC55]" : "w-1.5 bg-slate-700"}`}
              />
            ))}
          </div>
        </div>

        <div className="flex items-center justify-between gap-3 px-6 py-4 border-t border-amber-500/15">
          <button
            data-testid="onboarding-back-button"
            onClick={() => setStep((v) => Math.max(0, v - 1))}
            disabled={step === 0}
            className="flex items-center gap-1.5 text-xs font-heading uppercase tracking-widest text-slate-400 hover:text-[#E3BC55] transition-colors disabled:opacity-0"
          >
            <ArrowLeft className="w-4 h-4" /> Indietro
          </button>
          <button
            data-testid="onboarding-next-button"
            onClick={() => (last ? onDone() : setStep((v) => v + 1))}
            className="flex items-center gap-1.5 px-5 py-2.5 rounded-sm bg-[#E3BC55] text-black font-heading font-bold uppercase tracking-widest text-xs hover:bg-[#FFD700] transition-colors"
          >
            {last ? (<><Check className="w-4 h-4" /> Inizia</>) : (<>Avanti <ArrowRight className="w-4 h-4" /></>)}
          </button>
        </div>
      </div>
    </div>
  );
}
